export default __webpack_public_path__ + "static/montserrat-semibold-webfont-afd197c4f5de60a2be4d8cfa6b6d295c.woff";